export default __webpack_public_path__ + "static/media/Wristband of the Sepulcher.4594e16b.jpg";